import axios from 'axios';
import pLimit from 'p-limit';
export class ProofsLib {
    proofs;
    proofsProxyBaseUri;
    constructor(proofs, proofsProxyBaseUri) {
        this.proofs = proofs;
        this.proofsProxyBaseUri = proofsProxyBaseUri;
    }
    validationByPlatform = {
        DNS: async (proof) => {
            return axios
                .get(`${this.proofsProxyBaseUri}/dns`, {
                params: {
                    fqdn: proof.resource,
                },
            })
                .then((response) => {
                return {
                    valid: response.data?.includes(`pokproof:${proof.expect}`),
                };
            });
        },
        KYC: async (proof) => {
            return axios
                .get(`${this.proofsProxyBaseUri}/kyc`, {
                params: {
                    id: proof.resource,
                },
            })
                .then((response) => {
                return {
                    valid: response.data?.includes(proof.expect),
                };
            });
        },
        LINKEDIN: async (proof) => !proof.expect
            ? { valid: false }
            : axios
                .get(`${this.proofsProxyBaseUri}/linkedin`, {
                params: {
                    proofId: proof.expect,
                },
            })
                .then((response) => {
                const isProofPresent = response.data?.articleBody?.includes(proof.expect);
                const isFromSameOwner = response.data?.authorUrl?.includes(decodeURI(proof.method.concat('/').concat(proof.resource)));
                return { valid: isProofPresent && isFromSameOwner, location: response.data?.articleUrl };
            })
                .catch(async (e) => [400, 404].indexOf(e.response.status) >= 0
                ? { valid: false }
                : [429].indexOf(e.response.status) >= 0
                    ? { valid: false, throttled: true }
                    : Promise.reject(e)),
    };
    async proofsOf(target) {
        const limit = pLimit(3);
        return this.proofsCountAttempt(target, 0).then(async (count) => Promise.all([...Array(Number(count)).keys()].map(async (each) => limit(() => this.proofs.details(target, each).then((details) => this.parseDetails(details))))));
    }
    MAX_ATTEMPTS = 3;
    proofsCountAttempt = (target, attempt) => attempt < this.MAX_ATTEMPTS
        ? this.proofs.count(target).catch(() => this.proofsCountAttempt(target, attempt + 1))
        : Promise.reject(new Error(`gave up retrying to fetch proofs count for ${target}`));
    async validate(proof) {
        if (proof.active) {
            return this.validationByPlatform[proof.platform](proof);
        }
        return { valid: false };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseDetails(details) {
        return {
            ...this.parseBase(details[1]),
            expect: details[2],
            active: details[0],
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseBase(details) {
        return {
            platform: details[0],
            method: details[1],
            resource: details[2],
        };
    }
}
//# sourceMappingURL=index.js.map